/**
 * Counts in copy: "1 reel", "2 reels", "1,204 stored files" (QA 2026-10-16). English only (decision 19).
 * `many` defaults to `one` + "s"; pass it for irregular words ("1 is", "2 are" is not this helper's job).
 */
export function plural(n: number, one: string, many = `${one}s`): string {
  const v = Number.isFinite(n) ? n : 0;
  return `${v.toLocaleString('en-US')} ${v === 1 ? one : many}`;
}
